import type { Tile } from "../../types";

function getAllTilesForZoom(zoom: number) {
  const tileCount = 2 ** zoom;
  const tiles: Array<Tile> = [];

  for (let x = 0; x < tileCount; x++) {
    for (let y = 0; y < tileCount; y++) {
      tiles.push({ id: `${zoom}/${x}/${y}`, x, y, z: zoom });
    }
  }

  return tiles;
}

export { getAllTilesForZoom };
